import { forwardRef } from 'react';
import { IImageContainerProps } from './interface';
import Link from '@base/lib/ThemeLink';

type RefElement = HTMLDivElement | HTMLAnchorElement;

export const ImageContainer = forwardRef<RefElement, IImageContainerProps>((props, ref) => {
    const {
        href,
        target = '_self',
        pure,
        children,
        ...rest
    } = props;

    if (href) {
        return (
            <Link href={href}>
                {/*
                @ts-ignore*/}
                <a ref={ref}
                   target={target}
                   {...rest}
                >
                    {children}
                </a>
            </Link>
        )
    }
    return pure ? children : <div {...rest} ref={ref}>{children}</div>
});